import "../../App.css";
import Header from "../../components/header/Header";
import FormRegister from "../../components/form/FormRegister";
import About from "../../components/about/About";
import EventDetail from "../../components/event-detail/EventDetail";
import Agenda from "../../components/location/Agenda";
import Partner from "../../components/partner/partner";
import Footer from "../../components/footer/Footer";


function App() {
  return (
    <>
      <Header />
      <FormRegister />
      <About />
      <EventDetail />
      <Agenda />
      {/* <Partner /> */}
      <Footer />
    </>
  );
}

export default App;
